{
  "customer-form": {
    "field": {
      "available_points": "Verfügbare Punkte",
      "birthday": "Geburtstag",
      "black_listed": "Sperrliste",
      "black_listed_hint": "Kunden auf der Sperrliste können keinen Online-Termin mehr buchen",
      "communication_way": "Kontaktmethode",
      "email": "Email",
      "phone_nr": "Telefonnummer",
      "name": "Name",
      "new_point_balance": "Neuer Punktestand",
      "note": "Notiz",
      "notification_subscribed": "Werbebenachrichtigung",
      "surname": "Nachname",
      "update_point_balance": "Ändern um (+/-) Punkte"
    },
    "text": {
      "off": "AUS",
      "on": "EIN"
    }
  }
}
